export enum AnnouncementContentTypeKey {
  IMAGE = 'image',
  SCRIBE = 'scribe'
}
